import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'How long does a typical project take?',
      answer: 'Project timelines vary based on scope. Starter projects take 3 months, Professional projects 4-6 months, and Enterprise solutions are custom. We provide detailed timelines during the discovery phase.'
    },
    {
      question: 'What technologies do you specialize in?',
      answer: 'We specialize in React, Node.js, Python, Vue.js, Angular, and cloud platforms like AWS, Azure, and Google Cloud. We choose the best tech stack for your specific needs.'
    },
    {
      question: 'Do you provide post-launch support?',
      answer: 'Absolutely! All projects include post-launch support ranging from 30 days (Starter) to 6+ months (Enterprise). We also offer extended support packages.'
    },
    {
      question: 'Can you work with existing codebases?',
      answer: 'Yes! We can audit, refactor, and enhance existing systems. We offer custom quotes for legacy modernization and performance optimization.'
    },
    {
      question: 'What about security and compliance?',
      answer: 'Security is paramount. We implement industry-standard practices, data encryption, GDPR compliance, and regular security audits. Enterprise clients get dedicated security hardening.'
    },
    {
      question: 'How do you handle project communication?',
      answer: 'We maintain transparent communication through weekly updates, sprint reviews, and a dedicated project manager. Starter clients get email support; Professional and Enterprise get priority support channels.'
    }
  ];

  return (
    <section id="faq">
      <div className="section-header">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-subtitle">Everything you need to know about working with us</p>
      </div>
      <div className="faq-container">
        {faqs.map((item, index) => (
          <div 
            className={`faq-item fade-in ${activeIndex === index ? 'active' : ''}`} 
            key={index}
            onClick={() => setActiveIndex(activeIndex === index ? null : index)}
          >
            <div className="faq-question">
              <h4>{item.question}</h4>
              <span className="toggle-icon">{activeIndex === index ? '−' : '+'}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
